import { Pagination, Navigation, Scrollbar, A11y } from 'swiper';
import { Images } from 'assets/images';
import { useWindowDimensions } from 'hooks/useWindowDimensions';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'utils/routeNames';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/swiper.scss';
import 'swiper/modules/navigation/navigation.scss';
import 'swiper/modules/pagination/pagination.scss';

import {
  CardAndDescriptionBlock,
  CardBlock,
  CountryImage,
  TripDurationAndPrice,
  TripDuration,
  CardDescription,
  TripCountryAndPrice,
  CountryStarsPriceWrapper,
  TripCountryAndStars,
  TripPrice,
  PricePerPerson,
  TripCountry,
  ReadMore,
  DescriptionContainer,
} from './styled';

export const HotOffersCarousel = ({ hotOffers }) => {
  const navigate = useNavigate();
  const { width } = useWindowDimensions();
  const navigateToTour = (id) => {
    navigate(`${ROUTES.HOT_TOURS}/${id}`);
  };

  return (
    <Swiper
      slidesPerView={width < 768 ? 2 : 1}
      spaceBetween={10}
      slidesPerGroup={1}
      loop={true}
      pagination={{ clickable: true }}
      modules={[Pagination, Navigation, Scrollbar, A11y]}
      className="mySwiper"
    >
      {hotOffers?.map((item) => (
        <SwiperSlide key={item.id}>
          <CardAndDescriptionBlock>
            <CardBlock>
              <CountryImage background={item?.main_image}>
                <TripDurationAndPrice>
                  <TripDuration>
                    {item?.stay_days} Days / {item?.stay_nights} nights
                  </TripDuration>
                  <PricePerPerson> $ {item?.price}/Person </PricePerPerson>
                </TripDurationAndPrice>
              </CountryImage>

              <TripCountryAndPrice>
                <CountryStarsPriceWrapper>
                  <TripCountryAndStars>
                    <TripCountry> {item?.title} </TripCountry>
                    <img src={Images.stars} />
                  </TripCountryAndStars>
                  <TripPrice>$ {item?.price} </TripPrice>
                </CountryStarsPriceWrapper>

                <DescriptionContainer
                  isMedia
                  dangerouslySetInnerHTML={{ __html: item.description }}
                />
                <ReadMore onClick={() => navigateToTour(item?.id)} isMedia>
                  Read More <img src={Images.mainColorRightArrow} />
                </ReadMore>
              </TripCountryAndPrice>
            </CardBlock>
            <CardDescription>
              <TripCountryAndStars>
                <TripCountry>{item?.title}</TripCountry>
                <img src={Images.stars} />
              </TripCountryAndStars>
              <DescriptionContainer
                dangerouslySetInnerHTML={{ __html: item.description }}
              />

              <ReadMore onClick={() => navigateToTour(item?.id)}>
                Read More <img src={Images.mainColorRightArrow} />
              </ReadMore>
            </CardDescription>
          </CardAndDescriptionBlock>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};
